import { useTranslation } from "react-i18next";
import { SearchOutlined } from "@ant-design/icons";
import { Flex, Form, Layout, TableColumnsType, TableProps } from "antd";
import { ChangeEvent, KeyboardEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormInput from "../../../components/form-input/FormInput";
import PageHeader from "../../../components/page-header/PageHeader";
import TableData from "../../../components/table-data/TableData";
import { routesConfig } from "../../../config/routes";
import "./CourseList.scss";
import { globalStore } from "../../../stores/stores";
import dayjs from "dayjs";
import { postMoocCoursesSearch } from "../../../service/course-construct";

type ListStudentSystemProps = {
  title?: string;
};

const CourseList = ({ title }: ListStudentSystemProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { reload } = globalStore();
  const [listStudentSystem, setListStudentSystem] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [searchValue, setSearchValue] = useState<string>("");
  const [nameSort, setNameSort] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");

  const fetchData = async (searchParam: any) => {
    setLoading(true)
    try {
      const response = await postMoocCoursesSearch(searchParam);
      const { data } = response.data;
      setListStudentSystem(data?.content);
      setTotalPage(data?.totalElements);
      setLoading(false);
    } catch (error) { }
    finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData({
      size: pageSize,
      page: pageNumber,
      keyword: searchValue,
      status: [13],
      sort: nameSort ? [`${fieldSortOrder},${nameSort}`] : [],
    });
  }, [pageSize, pageNumber, nameSort, reload]);

  const dataColumnsReportCheckIn: TableColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 5,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    // {
    //   title: t("Mã khoá học", "Mã khoá học"),
    //   dataIndex: "id",
    //   key: "id",
    //   width: "250px",
    // },
    {
      title: t("Tên khoá học", "Tên khoá học"),
      dataIndex: "name",
      key: "name",
      width: 50,
      render: (_: any, record) => {
        return (
          <div
            onClick={() =>
              navigate(
                `${routesConfig.courseManagement}/${record.id}/${routesConfig.courseStudentList}`
              )
            }
            className="course-name-link flex"
          >
            <img
              className="course-image"
              style={{ width: 32, height: 32, marginRight: 10 }}
              loading="eager"
              alt=""
              src={
                record.imagePath
                  ? record.imagePath
                  : "/images/ic_school_placeholder.svg"
              }
            />
            <div className="course-info">
              <span className="course-title">{record.name}</span>
              <span>{record.enterpriseName}</span>
            </div>
          </div>
        );
      },
      sorter: true,
    },
    {
      title: t("Ngày tạo", "Ngày tạo"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: 20,
      render: (_: any, record) => {
        return (
          <div>{dayjs(record.createdDate).format("DD/MM/YYYY")}</div>
        );
      },
    },
    {
      title: t("Ngày xuất bản", "Ngày xuất bản"),
      dataIndex: "publicDate",
      key: "publicDate",
      width: 20,
      render: (_: any, record) => {
        return (
          <div>{dayjs(record.publicDate).format("DD/MM/YYYY")}</div>
        );
      },
    },
  ];

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("");
    }
  };

  const handleSearch = async (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      const searchParam = {
        size: pageSize,
        page: pageNumber,
        keyword: searchValue,
        status: [13],
      };
      setPageNumber(1);
      fetchData(searchParam);
    }
  };

  const handleSubmitSearch = () => {
    const searchParam = {
      size: pageSize,
      page: pageNumber,
      keyword: searchValue,
      status: [13],
    };
    setPageNumber(1);
    fetchData(searchParam);
  };

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
          ? "desc"
          : "";
    setNameSort(data);
    setFieldSortOrder(sorter.field);
  };

  return (
    <Layout className="page-header-group course-management-list">
      <Form.Provider>
        <div className={`page-header-group--layout`}>
          <div className="table-header--wrapper justify-between pb-6">
            <div className="table-header--left">
              <PageHeader title={title} />
            </div>
            <Flex>
              <FormInput
                placeholder={t("Nhập tên khoá học", "Nhập tên khoá học")}
                value={searchValue}
                onChange={handleChangeInput}
                onKeyPress={handleSearch}
                afterPrefixIcon={
                  <SearchOutlined onClick={handleSubmitSearch} />
                }
                style={{ width: "400px" }}
              />
            </Flex>
          </div>
        </div>
        <TableData
          dataTable={listStudentSystem}
          dataColumns={dataColumnsReportCheckIn}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          pageSize={pageSize}
          pagination={true}
          loadingTable={loading}
          scroll={{ x: 1500, y: 600 }}
          totalRecords={totalPage}
          handleTableChangeProps={handleTableChange}
        />
      </Form.Provider>
    </Layout>
  );
};

export default CourseList;
